import { connectionQuery } from './../../../helpers.class';
import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { Observable } from 'rxjs';
import { IGqlBaseOptions } from '../../../interfaces';
import { safeResolve } from '../../../rxjs';
import { IApiAddressType, IApiAddressTypeFilter } from '../../../types/types';
import { addressTypeQuery } from './address-type.operation';

@Injectable()
export class GqlAddressTypeService {
  public constructor(
    private apollo: Apollo
  ) { }

  public getAddressTypes(filters: IApiAddressTypeFilter[], options: IGqlBaseOptions): Observable<IApiAddressType[]> {
    return this.apollo.query(connectionQuery(addressTypeQuery, filters, options)).pipe(
      safeResolve(true)
    );
  }
}